<template>
  <div style="display: flex;justify-content: center;align-items: center;padding-top: 100px;">
    <el-form ref="submitFirstForm" :model="submitFirstForm" style="max-width: 700px;">

      <div v-for="item, index in submitFirstForm.channelList" :key="index">
        <div style="display: flex;align-items: center;" v-if="!(item.id == 4 || item.id == 8)">
          <img style="width: 30px; height: 30px;margin: 0 10px" :src="item.path" fit="cover" />
          <h3>
            {{ item.name }}证明链接
          </h3>
        </div>

        <el-form-item :prop="'channelList.' + index + '.url'" v-if="!(item.id == 4 || item.id == 8)"
          :rules="[{ required: true, message: '请输入证明链接', trigger: 'blur' }]">
          <el-input v-model="item.url" placeHolder="请输入证明链接" style="width: 400px;height: 50px;" />
        </el-form-item>
      </div>


      <h3 class="description">测评截图</h3>
      <el-form-item prop="final_draft_url" :rules="{ required: true, message: '请上传至少一项图片/视频', trigger: 'blur' }">
        <upload-list :list="submitFirstForm.final_draft_url" width="150px" height="150px"></upload-list>
      </el-form-item>
      <div style="padding: 80px 100px 30px 0;display: flex;align-items: center;justify-content: center;">
        <el-button @click="backHandler">返回</el-button>
        <el-button style="margin-left: 100px;" :loading="submitting"
          @click="onSubmitFirst('submitFirstForm')">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import UploadList from "@/components/UploadList/index.vue";
import Tinymce from "@/components/Tinymce";
import { zhongcao } from "@/api/order";
import { checkPlatform } from '@/utils/common'

export default {
  data: () => ({
    submitFirstForm: {
      order_id: null,
      final_draft_content: '',
      final_draft_url: [],
      channelList: {},
    },
    submitting: false,
    videoType: ['mp4', 'rmvb', 'wmv', 'avi', 'mov', 'flv'],
  }),
  components: {
    UploadList,
    Tinymce
  },
  props: {
    id: String | Number,
    channel_id: String | Number,
    title: String,
  },
  methods: {
    backHandler() {
      this.$router.back();
    },
    trunOff() {
      // this.showModal = false;
    },
    onSubmitFirst(formName) {

      console.log('this.submitFirstForm.channelList', this.submitFirstForm.channelList)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {


          try {
            this.submitting = true;

            let final_draft_url = this.submitFirstForm.final_draft_url.map((item) => {
              return {
                path: item,
                type: this.videoType.indexOf(item.substring(item.lastIndexOf('.') + 1)) == -1 ? 1 : 2
              }
            })

            let final_draft_content = {}
            this.submitFirstForm.channelList.forEach(item => {
              if (item.id == 4 || item.id == 8) {
                // final_draft_content[item.id] = []
              } else {
                final_draft_content[item.id] = item.url
              }
            })
            // let final_draft_content = {
            //   [this.channel_id]: this.submitFirstForm.final_draft_content
            // }

            await zhongcao.finalDraftSubmit({ ...this.submitFirstForm, final_draft_url, final_draft_content });
            this.$message({
              message: "提交成功!",
              type: "success",
            });
            this.backHandler()
          } catch {
            this.$message.error("出错了!");
          } finally {
            this.submitting = false;
          }
        }
      });
    },
    checkPlatform,


  },
  computed: {
    platform() {
      return this.checkPlatform(this.channel_id)
    }
  },
  watch: {
    submitFirstForm: {
      handler(val) {
        if (val.final_draft_url.length > 0) {
          this.$refs.submitFirstForm.validateField('final_draft_url');
        }
      },
      deep: true
    }

  },
  created() {
    this.submitFirstForm.order_id = this.id
    let list = this.channel_id.split(',')
    this.submitFirstForm.channelList = list.map(item => {
      return {
        id: item,
        name: this.checkPlatform(item).name,
        path: this.checkPlatform(item).path,
        url: '',
      }
    })
    console.log('this.submitFirstForm.channelList', this.submitFirstForm.channelList)
    // this.submitFirstForm.final_draft_content[this.channel_id] = ''
  },
};
</script>

<style lang="scss" scoped>
.description {
  padding: 0 0 10px 0;
  background: url('~@/assets/tagBottom.png') no-repeat 0 10px;
  background-size: 60px 15px;
}
</style>
